import React from "react";
import { Card } from "semantic-ui-react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { encodeStateUrl } from "../../helpers/clubHelper";

const StateCard = ({ _id, country, state, showClubs }, handleClick) => {
  return (
    <Card
      centered
      header={state}
      meta={country}
      description="" // TODO: Replcae placeholder text
      as={Link}
      to={encodeStateUrl({ country, state })}
      key={`${country}-${state}`}
    />
  );
};

StateCard.defaultProps = {
  history: {}
};

StateCard.propTypes = {
  _id: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  state: PropTypes.string.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func
  })
};

export default StateCard;



// WEBPACK FOOTER //
// ./src/components/StateList/StateCard.js